import React from 'react';
import './style.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LoadingButton = function LoadingButton(_ref) {
  var onClick = _ref.onClick,
    children = _ref.children,
    className = _ref.className,
    loading = _ref.loading,
    hideButton = _ref.hideButton,
    disabled = _ref.disabled;
  return /*#__PURE__*/_jsxs("button", {
    onClick: onClick,
    disabled: disabled // Ensure the button is disabled when `disabled` or `loading` is true
    ,
    className: "relative inline-flex items-center justify-center  px-4 py-2 rounded-md ".concat(className),
    children: [/*#__PURE__*/_jsx("span", {
      className: "absolute inset-0 flex items-center justify-center ".concat(loading ? 'block' : 'hidden'),
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex space-x-1",
        children: [/*#__PURE__*/_jsx("div", {
          className: "dot ".concat(hideButton ? 'bg-gray-600' : 'bg-white', " w-2.5 h-2.5 rounded-full")
        }), /*#__PURE__*/_jsx("div", {
          className: "dot ".concat(hideButton ? 'bg-gray-600' : 'bg-white', " w-2.5 h-2.5 rounded-full")
        }), /*#__PURE__*/_jsx("div", {
          className: "dot ".concat(hideButton ? 'bg-gray-600' : 'bg-white', " w-2.5 h-2.5 rounded-full")
        }), /*#__PURE__*/_jsx("div", {
          className: "dot ".concat(hideButton ? 'bg-gray-600' : 'bg-white', " w-2.5 h-2.5 rounded-full")
        })]
      })
    }), !hideButton && /*#__PURE__*/_jsx("span", {
      className: "".concat(loading ? 'opacity-0' : 'opacity-100', " transition-opacity"),
      children: children
    })]
  });
};
export default LoadingButton;